/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Olusola Akinbode",
  title: "Hi, I'm Olusola",
  subTitle: emoji(
    "I'm an enthusiastic frontend developer 🚀 dedicated to creating exceptional web applications. Proficient in HTML, CSS, SASS, JavaScript, React.js, Next.js, Node.js, and various frameworks, I specialize in building dynamic, responsive web solutions."
   
  ),
  displayGreeting: true, // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/olusoladav",
  linkedin: "https://www.linkedin.com/in/olusoladav/",
  gmail: "akinbodeoluosola9611@gmail.com",
  // gitlab: "https://gitlab.com/",
  twitter: "https://twitter.com/olusola_dav",
  facebook: "https://web.facebook.com/akinbode.sola.52",
  //medium: "https://medium.com/@davidrakosi",
 // stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/olusola_digitalArt/',
  whatsApp: 'https://wa.me/2348032158383',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "A PASSIONATE WEB DEVELOPER WHO COMBINES THE ART OF DESIGN WITH ART OF PROGRAMMING",
  skills: [
    emoji(
      "⚡ utilizing programming capabilities in HTML, CSS, Bootstrap, Sass, JavaScript, React.js and other libraries as needed"
    ),
    emoji(
      "⚡ converting mock-ups into HTML, CSS, Sass, JavaScript, and React.js."
    ),
    emoji(
      "⚡ driving continuous improvement by staying updated on front-end technology trends and ensuring the use of best practices across all tasks"
    ),
    emoji("⚡ Designing user flows and wireframes"),
    emoji(
      "⚡ Creating responsive and  interactive prototypes for web and mobile applications"
    ),
    emoji(
      "⚡ Developing features and functionalities that enhance the user experience"
    ),

    emoji("⚡ Teaching Graphic design, UI/UX design and Web development"),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node",
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fab fa-next"
    },

    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Obafemi University Ile-Ife, Nigeria",
      logo: require("./assets/images/OAU.jpg"),
      subHeader: "B.A Education (Fine and Applied Arts) || 3.6 GPA",
      duration: "August 2016 - February 2020",
      desc: "Participated in the practical and theoretical assessment of the relevant courses listed below.",
      descBullets: [
        "Book and Packaging Designs",
        "Cartooning and Animation",
        "Computer and Multimedia Graphics",
        "Introduction to Graphic Design",
        "Photography",
        "Illustration and Visualization",
        "Advance Draughtmanship",
        "Poster Designs",
      ],
    },
    // {
    //   schoolName: "Baptist Model High School, Eruwa, Oyo State",
    //   logo: require("./assets/images/BMHS.jpg"),
    //   subHeader: "SSCE, WAEC, NECO",
    //   duration: "September 2008 - July 2014",
    // },
    // {
    //   schoolName: "King’s Seed Nursery and Primary School, Eruwa, Oyo State",
    //   logo: require("./assets/images/KSS.jpg"),
    //   subHeader: "Primary School Certificate",
    //   duration: "October 2002 - July 2008",
    // },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "HTML / JSX",
      progressPercentage: "98%", //Insert relative proficiency in percentage
    },
    {
      Stack: "CSS / SASS", //Insert stack or technology you have experience in
      progressPercentage: "90%", //Insert relative proficiency in percentage
    },
    {
      Stack: "TailwindCSS", //Insert stack or technology you have experience in
      progressPercentage: "98%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Chacra UI", //Insert stack or technology you have experience in
      progressPercentage: "95%", //Insert relative proficiency in percentage
    },
    {
      Stack: "javaScript", //Insert stack or technology you have experience in
      progressPercentage: "90%", //Insert relative proficiency in percentage
    },
    {
      Stack: "React.JS", //Insert stack or technology you have experience in
      progressPercentage: "85%", //Insert relative proficiency in percentage
    },
    // {
    //   Stack: "Next.Js", //Insert stack or technology you have experience in
    //   progressPercentage: "70%" //Insert relative proficiency in percentage
    // },
    {
      Stack: "Node.Js", //Insert stack or technology you have experience in
      progressPercentage: "50%", //Insert relative proficiency in percentage
    },
    {
      Stack: "MongoDB", //Insert stack or technology you have experience in
      progressPercentage: "60%", //Insert relative proficiency in percentage
    },
    {
      Stack: "UI/UX Design",
      progressPercentage: "80%",
    },
    // {
    //   Stack: "Programming",
    //   progressPercentage: "70%"
    // }
  ],
  displayCodersrank: true, // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
}

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Junior Frontend developer",
      company: "Alot digital Solutions",
      companylogo: require("./assets/images/alot-logo.svg"),
      date: "February 2023 – Present",
      desc: "Fulltime frontend developer",
      descBullets: [
        "Converting mockups into maitainable web page using, React.js, TailwindCSS, Chackra UI and Next.js",
        "Developing and implementing front-end architecture to support user interface concepts.",
        "Developing and implementing highly responsive user interface components using react concepts.",
        "Building reusable components and front-end libraries for future use",
      ],
    },
    {
      role: "ICT Instructor/Graphic Designer",
      company: "Destiny International College, Osogbo",
      companylogo: require("./assets/images/DIC_logo.jpg"),
      date: "September 2021 – July 2022",
      desc: "Made graphic designs and tutored HTML/CSS",
      descBullets: [
        "based on the requirements, I conceptualized designs (both print and e-fliers) for the school.",
        "In collaboration with a copywriter and a social media marketer, I created compelling designs.",
        "I coached IGCSE students Web creation (HTML and CSS)",
        "fixed software and minor hardware issues on the Learners' computers (Laptop).",
      ],
    },
    {
      role: "Frontend Developer Intern",
      company: "MobileXcetera",
      companylogo: require("./assets/images/MobileXcetera_logo.png"),
      date: "May 2021 - December 2022",
      desc: "Assisted and contributed to the development team",
      descBullets: [
        "collaborated closely with lead developers to design products and solutions to various user and infrastructure issues.",
        "I used HTML, CSS, Bootstrap, Sass, JavaScript, React.js, and other libraries to program interfaces for users",
        "mock-ups were converted into HTML, CSS, Sass, JavaScript, and React.js",
        "kept abreast with frontend technology trends, guaranteeing the application of best practices throughout all jobs.",
        "User flows, process flows, site maps, and wireframes were used to communicate design concepts.",
        "ensured that technical documentation, such as configuration manuals and userflow, complies with requirements.",
      ],
    },

    {
      role: "UI/UX Designer",
      company: "Datrisoft Initiative",
      companylogo: require("./assets/images/datrisoft.png"),
      date: "October 2020 - May 2021",
      desc: "Created user interface mockups and prototypes",
      descBullets: [
        "worked closely with the technical team to deliver useful features and met client and business requirements.",
        "performed research by interviewing the clients, users, external customers and different stakeholders.",
        "Rough sketch were created and presented to internal teams and key stakeholders.",
        "created unique graphic designs (e.g. logo, icons, and cover pictures)",
        "Designed UI mockups and prototypes that clearly show how sites work and appear.",
        "Condected user testing",
      ],
    },
  ],
}

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "drakosi99", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Company Projects",
  subtitle: "PROJECTS OF STARTUPS AND COMPANIES ON WHICH I HAVE WORKED",
  projects: [
    {
      image: require("./assets/images/d-lighterTutor-logo.jpg"),
      projectName: "D-ligher Tutor's Website",
      projectDesc:
        "I created the D-lighter Tutor websites alongside my team member using Next.js, Sass and TailwindCSS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://d-lightertutor.com/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/grace-hands.png"),
      projectName: "Research Training Landing page",
      projectDesc:
        "I created the Grace Hands Research Institute's research training landing page using React.js.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://grace-hands.netlify.app/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: require("./assets/images/transferpay-logo.png"),
      projectName: "TransferPay",
      projectDesc:
        "During my internship at MobileXcetera, I worked on the user dashboard of the Transferpay web application.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://transferpay.ng/",
        },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
}

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Trainings and Certifications 🏆 "),
  subtitle:
    "Trainings/online courses, certifications, and projects completed while taking such courses",

  achievementsCards: [
    {
      title: "Complete React Developer in 2022 (w/ Redux, Hooks, GraphQL)",
      subtitle:
        "Zero to Master React.js course on Udemy. It covers a small project and an online store that includes technologies like React, Redux, React Hooks, React Router, Context API, Firebase, Redux-Saga, SASS, and React Components and is similar to Shopify. It is a full-stack app that uses Firebase (MERN stack).",
      image: "https://i.ibb.co/55Lm5Zc/training-cover-05.jpg",
      footerLink: [
        {
          name: "final project",
          url: "https://asher-cloth.netlify.app/",
        },
      ],
    },
    {
      title: "The Complete JavaScript Course 2022: From Zero to Expert!",
      subtitle:
        "Jonas Schmedtmann's JavaScript course on Udemy is suitable for students of all levels! It aids in the mastery of JavaScript through projects, challenges, and theory.",
      image: "https://i.ibb.co/G0Bm5wf/jonas-js.jpg",
      footerLink: [
        { name: "first project", url: "https://guesshidden.netlify.app/" },
      ],
    },

    {
      title: "Advanced CSS and Sass: Flexbox, Grid, Animations and More!",
      subtitle:
        "Advanced and modern CSS course by Jonas Schmedtmann on Udemy. Flexbox, CSS Grid, responsive design, and many more topics are covered.",
      image: "https://i.ibb.co/ysyGgg9/training-cover-02.jpg",
      footerLink: [
        {
          name: "first project",
          url: "https://natours-c.netlify.app/",
        },
        {
          name: "Second project",
          url: "https://primal-hotel.netlify.app/",
        },
        {
          name: "Final Project",
          url: "https://nexter-h.netlify.app/",
        },
      ],
    },

    {
      title: "Become a Software Developer",
      subtitle:
        "Software Developer Certifcate of completion Issued by Linkedln Learning. The learning path provides a broad perspective on core technologies for web development, software development, and databases. It introduces common tools and the bigger picture of how development careers work.",
      image: "https://i.ibb.co/pxHpWtK/training-cover-04.jpg",
      footerLink: [
        {
          name: "Fundamentals Certification",
          url: "https://drive.google.com/file/d/1I5tpfyt9nCF5ITcvP9JNX53y-P40pjsg/view?usp=sharing",
        },
        {
          name: "Certificate of completion",
          url: "https://drive.google.com/file/d/1lGaZGFl8HHfYFKQ9IdCmN7HMSy6XA-2j/view?usp=sharing",
        },
      ],
    },

    {
      title: "Build Responsive Real-World Websites with HTML and CSS",
      subtitle:
        "The first web development course that got me started in programming, as well as my first website built using HTML and CSS",
      image: "https://i.ibb.co/SmddCff/training-cover-01.jpg",
      footerLink: [
        { name: "Final project", url: "https://maritevents.netlify.app/" },
      ],
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Personal Projects",
  subtitle:
    "Some of my personal project and a client landing pages have been developed.",

  blogs: [
    {
      image: "./assets/images/cloths.png",
      url: "https://mathgame-multiplicationtable.netlify.app/",
      title: "Multiplication Table MathGame",
      description:
        "A math game to drill and practice multiplication for children. The game was created with React.js",
    },
    {
      image: "./assets/images/cloths.png",
      url: "https://grace-hands.netlify.app",
      title: "Grace hands Data Analysis training",
      description:
        "Grace Hands Research Institute's training landing page built using React.js, Bootstrap, and Sass.",
    },
    {
      image: "./assets/images/cloths.png",
      url: "https://olusoladav.netlify.app/",
      title: "Graphic portfolio",
      description:
        "My personal portfolio for some of the graphic design work I did during my undergraduate studies, made with HTML/CSS, Bootstrap, and Javascript.",
    },
    {
      image: "./assets/images/cloths.png",
      url: "https://chatscrumboard.netlify.app/",
      title: "Drag and Drop Chatscrumboard",
      description:
        "a dragable scrumboard with an authentication page (Sign-up and Sign-in), for scheduling daily and weekly tasks ",
    },
  ],
  display: true, // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Do you want to talk about a project, make me a job offer, or just say hello? Everyone has access to my Inbox.",
  number: "+2348032158383",
  email_address: "akinbodeolusola9611@gmail.com",
};

// Twitter Section

const twitterDetails = {
  userName: "olusola_dav", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
